export var ChipBackgroundColor;

(function (ChipBackgroundColor) {
  ChipBackgroundColor["Default"] = "default";
  ChipBackgroundColor["Red"] = "red";
  ChipBackgroundColor["Blue"] = "blue";
  ChipBackgroundColor["Yellow"] = "yellow";
  ChipBackgroundColor["Green"] = "green";
  ChipBackgroundColor["Purple"] = "purple";
  ChipBackgroundColor["Pink"] = "pink";
})(ChipBackgroundColor || (ChipBackgroundColor = {}));

export var ChipColorScheme;

(function (ChipColorScheme) {
  ChipColorScheme["Default"] = "default";
  ChipColorScheme["DarkBackground"] = "darkBackground";
})(ChipColorScheme || (ChipColorScheme = {}));

export var ChipVariant;

(function (ChipVariant) {
  ChipVariant["Filled"] = "filled";
  ChipVariant["Outlined"] = "outlined";
})(ChipVariant || (ChipVariant = {}));

export var ChipSize;

(function (ChipSize) {
  ChipSize["ExtraSmall"] = "extraSmall";
  ChipSize["Small"] = "small";
  ChipSize["Default"] = "default";
})(ChipSize || (ChipSize = {}));

export var ChipIconPosition;

(function (ChipIconPosition) {
  ChipIconPosition["Trailing"] = "trailing";
  ChipIconPosition["Leading"] = "leading";
})(ChipIconPosition || (ChipIconPosition = {}));

export var ChipDismissTrigger;

(function (ChipDismissTrigger) {
  ChipDismissTrigger["Keyboard"] = "keyboard";
  ChipDismissTrigger["Mouse"] = "mouse";
})(ChipDismissTrigger || (ChipDismissTrigger = {}));